import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import {
  useGetOnboardingQuery,
  useUpdateOnboardingMutation,
} from '../../../store/api/onboardingApi';
import WizardCard from '../WizardCard';
import GoLiveChecklist from '../../dashboard/GoLiveChecklist';

/**
 * Screen 5. Celebrate the first test payment and mark onboarding completed.
 * Surfaces the go-live checklist (not forced); it persists on the dashboard.
 */
const Success = () => {
  const navigate = useNavigate();
  const { data: state } = useGetOnboardingQuery();
  const [updateOnboarding] = useUpdateOnboardingMutation();

  // Reaching this screen means onboarding is done. Persist once.
  useEffect(() => {
    if (state && state.onboarding_status !== 'completed') {
      updateOnboarding({ onboarding_status: 'completed' });
    }
  }, [state, updateOnboarding]);

  return (
    <WizardCard
      title="Nice. Your first payment went through."
      subtitle="You have seen MaxelPay work end to end. Here is what to do when you are ready to go live."
      primaryLabel="Go to dashboard"
      onPrimary={() => navigate('/dashboard')}
    >
      <div className="wiz-success-badge" aria-hidden="true">
        <CheckCircle2 size={40} />
      </div>
      <GoLiveChecklist goLiveStatus={state?.go_live_status} />
    </WizardCard>
  );
};

export default Success;
